<script setup lang="ts">
// Components
import { BaseEmptyState } from '@magma-app/magma-lapilli';
</script>

<template>
  <div class="mx-auto flex h-screen items-center justify-center">
    <BaseEmptyState type="no-relation-selected" />
  </div>
</template>
